<template>
  <v-card>
    <rs-action
      :to="{
        name: 'definitions.periodical-assessments.create',
        params: { budgetId: this.budgetId },
      }"
    >
      Periyodik Borçlandırma Oluştur
    </rs-action>
    <rs-action @click="calculateBudget"> Hesapla </rs-action>
    <v-card-text>
      <v-data-table
        v-if="budgetId"
        v-bind="dataTableAttrs"
        :headers="headersShown"
        :items="list"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="total"
        :items-per-page.sync="itemsPerPage"
      >
        <template v-slot:top>
          <rs-table-title-bar
            v-if="$refs.headSearch"
            title="BB Tip Sonuç"
            icon=""
            @clear-filters="$refs.headSearch.reset"
            @reload="loadList"
            hide-edit
            :search.sync="search.query"
            v-bind="titleBarAttrs"
          >
          </rs-table-title-bar>
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:body.prepend="{ headers }">
          <rs-table-head-search
            :headers="headers"
            :search.sync="search"
            ref="headSearch"
          />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:body.append="{ headers }">
          <rs-table-foot-totals
            :headers="headers"
            :totals="footTotals"
            v-if="list.length > 0"
          />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.other_income_amount="{ value }">
          <rs-table-cell-number price :value="value" />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.expense_amount="{ value }">
          <rs-table-cell-number price :value="value" />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.exempt_amount="{ value }">
          <rs-table-cell-number price :value="value" />
        </template>

        <!-- eslint-disable-next-line -->
        <template v-slot:item.amount="{ value }">
          <rs-table-cell-number price :value="value" />
        </template>

        <!-- eslint-enable -->
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";
import { hasDataTable, hasExport } from "../../../../mixins";
import { mapGetters } from "vuex";

export default {
  mixins: [hasDataTable, hasExport],
  props: {
    /**
     * Budget ID
     */
    budgetId: {
      type: Number,
      required: true,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["houseTypes"]),
  },
  data() {
    return {
      titleBarAttrs: {
        exportUrl: () => "budget-house-types",
        exportParams: this.getParams,
      },
      headers: [
        {
          text: "BB Tipi",
          value: "house_type_name",
          searchable: "multiselect",
          searchValue: "house_type_ids",
          width: "75px",
          align: "center",
          options: () => this.houseTypes,
        },
        {
          text: "Diğer Gelir Tutar",
          value: "other_income_amount",
          searchable: "number",
          align: "end",
        },
        {
          text: "Gider Tutar",
          value: "expense_amount",
          searchable: "number",
          align: "end",
        },
        {
          text: "Muafiyet Tutar",
          value: "exempt_amount",
          searchable: "number",
          align: "end",
        },
        {
          text: "Aylık Net Tutar",
          value: "amount",
          searchable: "number",
          align: "end",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.loadList();
      this.generateExportColumns(this.headers);
    });
  },
  methods: {
    loadList() {
      if (this.isLoading || !this.budgetId) {
        return;
      }

      this.isLoading = true;
      this.list = [];
      this.footTotals = [];

      const params = this.getParams();

      this.$api
        .query(`budget-house-types`, { params })
        .then((response) => {
          if (response.data && response.data.data) {
            this.list = response.data.data;
          }

          if (response.data && response.data.meta) {
            this.total = response.data.meta.total;
            this.options.page = response.data.meta.current_page;
            this.itemsPerPage = response.data.meta.per_page;
            this.options.itemsPerPage = this.itemsPerPage;
            this.footTotals = response.data.meta.totals;
          }
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
    getParams() {
      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      params.budget_id = this.budgetId;
      params.order_by = "house_type_name";

      return params;
    },
    calculateBudget() {
      if (this.isLoading) {
        return false;
      }

      this.isLoading = true;

      this.$api
        .post(`budgets/${this.budgetId}/calculate`, {})
        .then(() => {
          this.$toast.success(this.$t("saved"));
          setTimeout(() => {
            this.loadList();
          }, 1000);
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
    search: {
      handler: debounce(function () {
        this.loadList();
      }),
      deep: true,
    },
    budgetId: {
      handler() {
        this.loadList();
      },
    },
  },
};
</script>
